import PropTypes from 'prop-types';
import TimeRangePicker from 'client/js/util/time_range_picker';

const ErrorLogFilters = ({ filters, onFilterChange, filterErrors }) => {
  return (
    <>
      <div className="filter-group">
        <label htmlFor="hostname-filter">Hostname:</label>
        <input
          id="hostname-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.hostname ? 'is-invalid' : ''}`}
          value={filters.hostname}
          onChange={(e) => onFilterChange('hostname', e.target.value)}
          placeholder="z.B. example.com"
        />
        {filterErrors.hostname && <div className="invalid-feedback">{filterErrors.hostname}</div>}
      </div>

      <div className="filter-group">
        <label htmlFor="client-ip-filter">Client IP:</label>
        <input
          id="client-ip-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.client_ip ? 'is-invalid' : ''}`}
          value={filters.client_ip}
          onChange={(e) => onFilterChange('client_ip', e.target.value)}
          placeholder="z.B. 192.168.1.1"
        />
        {filterErrors.client_ip && <div className="invalid-feedback">{filterErrors.client_ip}</div>}
      </div>

      <div className="filter-group">
        <label htmlFor="log-level-filter">Log Level:</label>
        <select
          id="log-level-filter"
          className={`form-control form-control-sm ${filterErrors.log_level ? 'is-invalid' : ''}`}
          value={filters.log_level}
          onChange={(e) => onFilterChange('log_level', e.target.value)}
        >
          <option value="">Alle Level</option>
          <option value="emergency">Emergency</option>
          <option value="alert">Alert</option>
          <option value="critical">Critical</option>
          <option value="error">Error</option>
          <option value="warning">Warning</option>
          <option value="notice">Notice</option>
          <option value="info">Info</option>
          <option value="debug">Debug</option>
        </select>
        {filterErrors.log_level && <div className="invalid-feedback">{filterErrors.log_level}</div>}
      </div>

      <div className="filter-group">
        <label htmlFor="module-filter">Modul:</label>
        <input
          id="module-filter"
          type="text"
          className={`form-control form-control-sm ${filterErrors.module ? 'is-invalid' : ''}`}
          value={filters.module}
          onChange={(e) => onFilterChange('module', e.target.value)}
          placeholder="z.B. core, ssl"
        />
        {filterErrors.module && <div className="invalid-feedback">{filterErrors.module}</div>}
      </div>

      <div className="filter-group">
        <label>Zeit:</label>
        <TimeRangePicker
          value={filters.from_time}
          onChange={(timeRange) => {
            if (timeRange) {
              onFilterChange('from_time', timeRange.from_time);
              onFilterChange('to_time', timeRange.to_time);
            } else {
              onFilterChange('from_time', '');
              onFilterChange('to_time', '');
            }
          }}
          error={filterErrors.from_time}
        />
      </div>

    </>
  );
};

ErrorLogFilters.propTypes = {
  filters: PropTypes.shape({
    hostname: PropTypes.string,
    client_ip: PropTypes.string,
    log_level: PropTypes.string,
    module: PropTypes.string,
    from_time: PropTypes.string,
    to_time: PropTypes.string
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filterErrors: PropTypes.object.isRequired
};

export default ErrorLogFilters;
